import _ from 'lodash';

// Mentions are stored the way the TipTap editor writes them:
//    <span data-type="mention" data-id="adi@monada.ai" data-label="..." data-mention-suggestion-char="@">@adi@monada.ai</span>
// Newer editor versions add attributes after data-id, so match whatever follows it.
const MENTION_REGEX = /<span data-type="mention" data-id="([^"]+)"[^>]*>@([^<]+)<\/span>/g;

const CHIP_STYLE = 'display:inline-block;padding:0 8px;margin:0 1px;border-radius:12px;font-weight:500;line-height:1.6;white-space:nowrap;';
const CHIP_OTHER = 'background:#e8eaf6;color:#3f50b5;';
const CHIP_ME = 'background:#3f50b5;color:#ffffff;';

// Render each stored mention as a tag chip: "@Name" (or the email when the user has no name),
// with the full email on hover. A mention of the viewer stands out so they see they were tagged.
function renderMentions({ html, me, users = [] }) {
    if (!html) return html;
    return html.replace(MENTION_REGEX, (match, email, label) => {
        const user = users.find(u => u?.email === email);
        // `label` comes out of stored HTML, so it is already escaped; a user's name is not.
        const text = user?.name ? _.escape(user.name) : label;
        const style = CHIP_STYLE + (email === me ? CHIP_ME : CHIP_OTHER);
        return `<span data-type="mention" data-id="${email}" title="${email}" style="${style}">@${text}</span>`;
    });
}

export { renderMentions };
